import {Cart} from "~/dto/Cart";

export class CartHelper {

    static getCart() {
        return useState("cart", () => {
            // useState's initializer runs on the server too (to seed the
            // SSR payload) — localStorage doesn't exist there.
            if (!import.meta.client) return Cart.createFromArray([]);
            const items = JSON.parse(localStorage.getItem("cart") || "[]");
            const promo = localStorage.getItem("cart_promo") || null;
            return Cart.createFromArray(items, promo);
        });
    }

    static saveCart() {
        if (!import.meta.client) return;
        const cart = CartHelper.getCart();
        localStorage.setItem("cart", JSON.stringify(cart.value.toArray()));
        if (cart.value.partnerCode) {
            localStorage.setItem("cart_promo", cart.value.partnerCode);
        } else {
            localStorage.removeItem("cart_promo");
        }
    }

}
